export const RESPONSE_TOOLBAR_LOCALE_ZHCHS = {
    more: 'æ´å¤',
};
